import { loginByUsername, logout, getUserById } from '../../api/user'
import { getToken, setToken, removeToken, setUser, getUserId, setUserId, removeUser, removeId } from '../../utils/auth'
/* eslint-disable no-console */
const user = {
  state: {
    userId: getUserId(),
    user: {},
    token: getToken(),
    name: ''
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_USER_ID: (state, userId) => {
      state.userId = userId
    },
    SET_USER: (state, user) => {
      state.user = user
    }
  },

  actions: {
    // 用户名登录
    LoginByUsername({ commit }, userInfo) {
      const username = userInfo.username.trim();
      return new Promise((resolve, reject) => {
        loginByUsername(username, userInfo.password).then(response => {
          const data = response.data;
          commit('SET_TOKEN', data['id']);
          commit('SET_USER_ID', data['userId']);
          setUserId(data['userId']);
          setToken(data['id']);
          resolve()
        }).catch(error => {
          // console.log(error)
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getUserById(getUserId()).then(response => {
          if (!response.data) {
            reject('Verification failed, please login again.')
          }
          const data = response.data;
          commit('SET_NAME', data['name']);
          commit('SET_USER', data);
          setUser(data);
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '');
          commit('SET_USER', {});
          removeToken();
          removeId();
          removeUser();
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '');
        commit('SET_USER', {});
        removeToken();
        removeId();
        removeUser();
        resolve()
      })
    },
  }
};

export default user
